import $ from 'jquery';
import widgetFactory from '../../widgetFactory';

const widgetName = 'countrySelect',
  baseClassname = 'js-countrySelect';

export default widgetFactory(widgetName, {
  options: {
    hideParentIfNone: true,
    usValue: 'US',
    caValue: 'CA',
    countrySelector: '[name*=\\[country\\]]',
    stateSelector: '[name*=\\[state\\]]',
    provinceSelector: '[name*=\\[province\\]]',
  },

  _create() {
    this._super(baseClassname);
    this._getElements();
    this._attachEvents();

    this.update();
  },

  _attachEvents() {
    let { $country } = this.elements;

    $country.on('change', (e) => {
      this.update();
    });
  },

  _getElements() {
    this.elements.$country = $(this.options.countrySelector, this.element);
    this.elements.$state = $(this.options.stateSelector, this.element);
    this.elements.$province = $(this.options.provinceSelector, this.element);
  },

  _toggleSelect($element, state) {
    let $select = $element;

    if (!$element.is('select')) {
      $select = $element.find('select');
    }

    $element.toggle(state);
    $select.prop('required', state);
  },

  update() {
    let { elements, options } = this,
      currentCountry = elements.$country.val(),
      showState = currentCountry === options.usValue,
      showProvince = currentCountry === options.caValue,
      $parent = elements.$state.parent();

    this._toggleSelect(elements.$state, showState);
    this._toggleSelect(elements.$province, showProvince);

    if (options.hideParentIfNone && !showState && !showProvince) {
      $parent.hide();
    } else {
      $parent.show();
    }
  },
});
